var yt = Object.defineProperty, vt = Object.defineProperties;
var xt = Object.getOwnPropertyDescriptors;
var Z = Object.getOwnPropertySymbols;
var pt = Object.prototype.hasOwnProperty, wt = Object.prototype.propertyIsEnumerable;
var G = (t, n, e) => n in t ? yt(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e, C = (t, n) => {
  for (var e in n || (n = {}))
    pt.call(n, e) && G(t, e, n[e]);
  if (Z)
    for (var e of Z(n))
      wt.call(n, e) && G(t, e, n[e]);
  return t;
}, J = (t, n) => vt(t, xt(n));
import { watch as dt, toRef as _t } from "vue";
function rt(t, n) {
  var e, r = 1;
  t == null && (t = 0), n == null && (n = 0);
  function i() {
    var o, l = e.length, f, h = 0, a = 0;
    for (o = 0; o < l; ++o)
      f = e[o], h += f.x, a += f.y;
    for (h = (h / l - t) * r, a = (a / l - n) * r, o = 0; o < l; ++o)
      f = e[o], f.x -= h, f.y -= a;
  }
  return i.initialize = function(o) {
    e = o;
  }, i.x = function(o) {
    return arguments.length ? (t = +o, i) : t;
  }, i.y = function(o) {
    return arguments.length ? (n = +o, i) : n;
  }, i.strength = function(o) {
    return arguments.length ? (r = +o, i) : r;
  }, i;
}
function mt(t) {
  const n = +this._x.call(null, t), e = +this._y.call(null, t);
  return it(this.cover(n, e), n, e, t);
}
function it(t, n, e, r) {
  if (isNaN(n) || isNaN(e))
    return t;
  var i, o = t._root, l = { data: r }, f = t._x0, h = t._y0, a = t._x1, v = t._y1, d, p, y, w, s, u, c, g;
  if (!o)
    return t._root = l, t;
  for (; o.length; )
    if ((s = n >= (d = (f + a) / 2)) ? f = d : a = d, (u = e >= (p = (h + v) / 2)) ? h = p : v = p, i = o, !(o = o[c = u << 1 | s]))
      return i[c] = l, t;
  if (y = +t._x.call(null, o.data), w = +t._y.call(null, o.data), n === y && e === w)
    return l.next = o, i ? i[c] = l : t._root = l, t;
  do
    i = i ? i[c] = new Array(4) : t._root = new Array(4), (s = n >= (d = (f + a) / 2)) ? f = d : a = d, (u = e >= (p = (h + v) / 2)) ? h = p : v = p;
  while ((c = u << 1 | s) === (g = (w >= p) << 1 | y >= d));
  return i[g] = o, i[c] = l, t;
}
function Nt(t) {
  var n, e, r = t.length, i, o, l = new Array(r), f = new Array(r), h = 1 / 0, a = 1 / 0, v = -1 / 0, d = -1 / 0;
  for (e = 0; e < r; ++e)
    isNaN(i = +this._x.call(null, n = t[e])) || isNaN(o = +this._y.call(null, n)) || (l[e] = i, f[e] = o, i < h && (h = i), i > v && (v = i), o < a && (a = o), o > d && (d = o));
  if (h > v || a > d)
    return this;
  for (this.cover(h, a).cover(v, d), e = 0; e < r; ++e)
    it(this, l[e], f[e], t[e]);
  return this;
}
function At(t, n) {
  if (isNaN(t = +t) || isNaN(n = +n))
    return this;
  var e = this._x0, r = this._y0, i = this._x1, o = this._y1;
  if (isNaN(e))
    i = (e = Math.floor(t)) + 1, o = (r = Math.floor(n)) + 1;
  else {
    for (var l = i - e || 1, f = this._root, h, a; e > t || t >= i || r > n || n >= o; )
      switch (a = (n < r) << 1 | t < e, h = new Array(4), h[a] = f, f = h, l *= 2, a) {
        case 0:
          i = e + l, o = r + l;
          break;
        case 1:
          e = i - l, o = r + l;
          break;
        case 2:
          i = e + l, r = o - l;
          break;
        case 3:
          e = i - l, r = o - l;
          break;
      }
    this._root && this._root.length && (this._root = f);
  }
  return this._x0 = e, this._y0 = r, this._x1 = i, this._y1 = o, this;
}
function Mt() {
  var t = [];
  return this.visit(function(n) {
    if (!n.length)
      do
        t.push(n.data);
      while (n = n.next);
  }), t;
}
function bt(t) {
  return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function z(t, n, e, r, i) {
  this.node = t, this.x0 = n, this.y0 = e, this.x1 = r, this.y1 = i;
}
function zt(t, n, e) {
  var r, i = this._x0, o = this._y0, l, f, h, a, v = this._x1, d = this._y1, p = [], y = this._root, w, s;
  for (y && p.push(new z(y, i, o, v, d)), e == null ? e = 1 / 0 : (i = t - e, o = n - e, v = t + e, d = n + e, e *= e); w = p.pop(); )
    if (!(!(y = w.node) || (l = w.x0) > v || (f = w.y0) > d || (h = w.x1) < i || (a = w.y1) < o))
      if (y.length) {
        var u = (l + h) / 2, c = (f + a) / 2;
        p.push(
          new z(y[3], u, c, h, a),
          new z(y[2], l, c, u, a),
          new z(y[1], u, f, h, c),
          new z(y[0], l, f, u, c)
        ), (s = (n >= c) << 1 | t >= u) && (w = p[p.length - 1], p[p.length - 1] = p[p.length - 1 - s], p[p.length - 1 - s] = w);
      } else {
        var g = t - +this._x.call(null, y.data), _ = n - +this._y.call(null, y.data), x = g * g + _ * _;
        if (x < e) {
          var m = Math.sqrt(e = x);
          i = t - m, o = n - m, v = t + m, d = n + m, r = y.data;
        }
      }
  return r;
}
function jt(t) {
  if (isNaN(v = +this._x.call(null, t)) || isNaN(d = +this._y.call(null, t)))
    return this;
  var n, e = this._root, r, i, o, l = this._x0, f = this._y0, h = this._x1, a = this._y1, v, d, p, y, w, s, u, c;
  if (!e)
    return this;
  if (e.length)
    for (; ; ) {
      if ((w = v >= (p = (l + h) / 2)) ? l = p : h = p, (s = d >= (y = (f + a) / 2)) ? f = y : a = y, n = e, !(e = e[u = s << 1 | w]))
        return this;
      if (!e.length)
        break;
      (n[u + 1 & 3] || n[u + 2 & 3] || n[u + 3 & 3]) && (r = n, c = u);
    }
  for (; e.data !== t; )
    if (i = e, !(e = e.next))
      return this;
  return (o = e.next) && delete e.next, i ? (o ? i.next = o : delete i.next, this) : n ? (o ? n[u] = o : delete n[u], (e = n[0] || n[1] || n[2] || n[3]) && e === (n[3] || n[2] || n[1] || n[0]) && !e.length && (r ? r[c] = e : this._root = e), this) : (this._root = o, this);
}
function Et(t) {
  for (var n = 0, e = t.length; n < e; ++n)
    this.remove(t[n]);
  return this;
}
function Lt() {
  return this._root;
}
function Dt() {
  var t = 0;
  return this.visit(function(n) {
    if (!n.length)
      do
        ++t;
      while (n = n.next);
  }), t;
}
function It(t) {
  var n = [], e, r = this._root, i, o, l, f, h;
  for (r && n.push(new z(r, this._x0, this._y0, this._x1, this._y1)); e = n.pop(); )
    if (!t(r = e.node, o = e.x0, l = e.y0, f = e.x1, h = e.y1) && r.length) {
      var a = (o + f) / 2, v = (l + h) / 2;
      (i = r[3]) && n.push(new z(i, a, v, f, h)), (i = r[2]) && n.push(new z(i, o, v, a, h)), (i = r[1]) && n.push(new z(i, a, l, f, v)), (i = r[0]) && n.push(new z(i, o, l, a, v));
    }
  return this;
}
function Ot(t) {
  var n = [], e = [], r;
  for (this._root && n.push(new z(this._root, this._x0, this._y0, this._x1, this._y1)); r = n.pop(); ) {
    var i = r.node;
    if (i.length) {
      var o, l = r.x0, f = r.y0, h = r.x1, a = r.y1, v = (l + h) / 2, d = (f + a) / 2;
      (o = i[0]) && n.push(new z(o, l, f, v, d)), (o = i[1]) && n.push(new z(o, v, f, h, d)), (o = i[2]) && n.push(new z(o, l, d, v, a)), (o = i[3]) && n.push(new z(o, v, d, h, a));
    }
    e.push(r);
  }
  for (; r = e.pop(); )
    t(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function kt(t) {
  return t[0];
}
function St(t) {
  return arguments.length ? (this._x = t, this) : this._x;
}
function Tt(t) {
  return t[1];
}
function Pt(t) {
  return arguments.length ? (this._y = t, this) : this._y;
}
function H(t, n, e) {
  var r = new V(n == null ? kt : n, e == null ? Tt : e, NaN, NaN, NaN, NaN);
  return t == null ? r : r.addAll(t);
}
function V(t, n, e, r, i, o) {
  this._x = t, this._y = n, this._x0 = e, this._y0 = r, this._x1 = i, this._y1 = o, this._root = void 0;
}
function U(t) {
  for (var n = { data: t.data }, e = n; t = t.next; )
    e = e.next = { data: t.data };
  return n;
}
var j = H.prototype = V.prototype;
j.copy = function() {
  var t = new V(this._x, this._y, this._x0, this._y0, this._x1, this._y1), n = this._root, e, r;
  if (!n)
    return t;
  if (!n.length)
    return t._root = U(n), t;
  for (e = [{ source: n, target: t._root = new Array(4) }]; n = e.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = n.source[i]) && (r.length ? e.push({ source: r, target: n.target[i] = new Array(4) }) : n.target[i] = U(r));
  return t;
};
j.add = mt;
j.addAll = Nt;
j.cover = At;
j.data = Mt;
j.extent = bt;
j.find = zt;
j.remove = jt;
j.removeAll = Et;
j.root = Lt;
j.size = Dt;
j.visit = It;
j.visitAfter = Ot;
j.x = St;
j.y = Pt;
function N(t) {
  return function() {
    return t;
  };
}
function k(t) {
  return (t() - 0.5) * 1e-6;
}
function Ft(t) {
  return t.x + t.vx;
}
function $t(t) {
  return t.y + t.vy;
}
function ot(t) {
  var n, e, r, i = 1, o = 1;
  typeof t != "function" && (t = N(t == null ? 1 : +t));
  function l() {
    for (var a, v = n.length, d, p, y, w, s, u, c = 0; c < o; ++c)
      for (d = H(n, Ft, $t).visitAfter(f), a = 0; a < v; ++a)
        p = n[a], s = e[p.index], u = s * s, y = p.x + p.vx, w = p.y + p.vy, d.visit(g);
    function g(_, x, m, b, E) {
      var A = _.data, L = _.r, M = s + L;
      if (A) {
        if (A.index > p.index) {
          var I = y - A.x - A.vx, O = w - A.y - A.vy, D = I * I + O * O;
          D < M * M && (I === 0 && (I = k(r), D += I * I), O === 0 && (O = k(r), D += O * O), D = (M - (D = Math.sqrt(D))) / D * i, p.vx += (I *= D) * (M = (L *= L) / (u + L)), p.vy += (O *= D) * M, A.vx -= I * (M = 1 - M), A.vy -= O * M);
        }
        return;
      }
      return x > y + M || b < y - M || m > w + M || E < w - M;
    }
  }
  function f(a) {
    if (a.data)
      return a.r = e[a.data.index];
    for (var v = a.r = 0; v < 4; ++v)
      a[v] && a[v].r > a.r && (a.r = a[v].r);
  }
  function h() {
    if (n) {
      var a, v = n.length, d;
      for (e = new Array(v), a = 0; a < v; ++a)
        d = n[a], e[d.index] = +t(d, a, n);
    }
  }
  return l.initialize = function(a, v) {
    n = a, r = v, h();
  }, l.iterations = function(a) {
    return arguments.length ? (o = +a, l) : o;
  }, l.strength = function(a) {
    return arguments.length ? (i = +a, l) : i;
  }, l.radius = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : N(+a), h(), l) : t;
  }, l;
}
function Bt(t) {
  return t.index;
}
function q(t, n) {
  var e = t.get(n);
  if (!e)
    throw new Error("node not found: " + n);
  return e;
}
function ft(t) {
  var n = Bt, e = d, r, i = N(30), o, l, f, h, a, v = 1;
  t == null && (t = []);
  function d(u) {
    return 1 / Math.min(f[u.source.index], f[u.target.index]);
  }
  function p(u) {
    for (var c = 0, g = t.length; c < v; ++c)
      for (var _ = 0, x, m, b, E, A, L, M; _ < g; ++_)
        x = t[_], m = x.source, b = x.target, E = b.x + b.vx - m.x - m.vx || k(a), A = b.y + b.vy - m.y - m.vy || k(a), L = Math.sqrt(E * E + A * A), L = (L - o[_]) / L * u * r[_], E *= L, A *= L, b.vx -= E * (M = h[_]), b.vy -= A * M, m.vx += E * (M = 1 - M), m.vy += A * M;
  }
  function y() {
    if (l) {
      var u, c = l.length, g = t.length, _ = new Map(l.map((m, b) => [n(m, b, l), m])), x;
      for (u = 0, f = new Array(c); u < g; ++u)
        x = t[u], x.index = u, typeof x.source != "object" && (x.source = q(_, x.source)), typeof x.target != "object" && (x.target = q(_, x.target)), f[x.source.index] = (f[x.source.index] || 0) + 1, f[x.target.index] = (f[x.target.index] || 0) + 1;
      for (u = 0, h = new Array(g); u < g; ++u)
        x = t[u], h[u] = f[x.source.index] / (f[x.source.index] + f[x.target.index]);
      r = new Array(g), w(), o = new Array(g), s();
    }
  }
  function w() {
    if (l)
      for (var u = 0, c = t.length; u < c; ++u)
        r[u] = +e(t[u], u, t);
  }
  function s() {
    if (l)
      for (var u = 0, c = t.length; u < c; ++u)
        o[u] = +i(t[u], u, t);
  }
  return p.initialize = function(u, c) {
    l = u, a = c, y();
  }, p.links = function(u) {
    return arguments.length ? (t = u, y(), p) : t;
  }, p.id = function(u) {
    return arguments.length ? (n = u, p) : n;
  }, p.iterations = function(u) {
    return arguments.length ? (v = +u, p) : v;
  }, p.strength = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : N(+u), w(), p) : e;
  }, p.distance = function(u) {
    return arguments.length ? (i = typeof u == "function" ? u : N(+u), s(), p) : i;
  }, p;
}
var Ct = { value: () => {
} };
function at() {
  for (var t = 0, n = arguments.length, e = {}, r; t < n; ++t) {
    if (!(r = arguments[t] + "") || r in e || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    e[r] = [];
  }
  return new R(e);
}
function R(t) {
  this._ = t;
}
function Rt(t, n) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var r = "", i = e.indexOf(".");
    if (i >= 0 && (r = e.slice(i + 1), e = e.slice(0, i)), e && !n.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    return { type: e, name: r };
  });
}
R.prototype = at.prototype = {
  constructor: R,
  on: function(t, n) {
    var e = this._, r = Rt(t + "", e), i, o = -1, l = r.length;
    if (arguments.length < 2) {
      for (; ++o < l; )
        if ((i = (t = r[o]).type) && (i = Kt(e[i], t.name)))
          return i;
      return;
    }
    if (n != null && typeof n != "function")
      throw new Error("invalid callback: " + n);
    for (; ++o < l; )
      if (i = (t = r[o]).type)
        e[i] = tt(e[i], t.name, n);
      else if (n == null)
        for (i in e)
          e[i] = tt(e[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, n = this._;
    for (var e in n)
      t[e] = n[e].slice();
    return new R(t);
  },
  call: function(t, n) {
    if ((i = arguments.length - 2) > 0)
      for (var e = new Array(i), r = 0, i, o; r < i; ++r)
        e[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (o = this._[t], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(n, e);
  },
  apply: function(t, n, e) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(n, e);
  }
};
function Kt(t, n) {
  for (var e = 0, r = t.length, i; e < r; ++e)
    if ((i = t[e]).name === n)
      return i.value;
}
function tt(t, n, e) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === n) {
      t[r] = Ct, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return e != null && t.push({ name: n, value: e }), t;
}
var T = 0, F = 0, P = 0, ut = 1e3, K, $, Q = 0, S = 0, W = 0, B = typeof performance == "object" && performance.now ? performance : Date, st = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function lt() {
  return S || (st(Qt), S = B.now() + W);
}
function Qt() {
  S = 0;
}
function X() {
  this._call = this._time = this._next = null;
}
X.prototype = ct.prototype = {
  constructor: X,
  restart: function(t, n, e) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    e = (e == null ? lt() : +e) + (n == null ? 0 : +n), !this._next && $ !== this && ($ ? $._next = this : K = this, $ = this), this._call = t, this._time = e, Y();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Y());
  }
};
function ct(t, n, e) {
  var r = new X();
  return r.restart(t, n, e), r;
}
function Wt() {
  lt(), ++T;
  for (var t = K, n; t; )
    (n = S - t._time) >= 0 && t._call.call(void 0, n), t = t._next;
  --T;
}
function nt() {
  S = (Q = B.now()) + W, T = F = 0;
  try {
    Wt();
  } finally {
    T = 0, Yt(), S = 0;
  }
}
function Xt() {
  var t = B.now(), n = t - Q;
  n > ut && (W -= n, Q = t);
}
function Yt() {
  for (var t, n = K, e, r = 1 / 0; n; )
    n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : K = e);
  $ = t, Y(r);
}
function Y(t) {
  if (!T) {
    F && (F = clearTimeout(F));
    var n = t - S;
    n > 24 ? (t < 1 / 0 && (F = setTimeout(nt, t - B.now() - W)), P && (P = clearInterval(P))) : (P || (Q = B.now(), P = setInterval(Xt, ut)), T = 1, st(nt));
  }
}
const Ht = 1664525, Vt = 1013904223, et = 4294967296;
function Zt() {
  let t = 1;
  return () => (t = (Ht * t + Vt) % et) / et;
}
function Gt(t) {
  return t.x;
}
function Jt(t) {
  return t.y;
}
var Ut = 10, qt = Math.PI * (3 - Math.sqrt(5));
function ht(t) {
  var n, e = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), o = 0, l = 0.6, f = /* @__PURE__ */ new Map(), h = ct(d), a = at("tick", "end"), v = Zt();
  t == null && (t = []);
  function d() {
    p(), a.call("tick", n), e < r && (h.stop(), a.call("end", n));
  }
  function p(s) {
    var u, c = t.length, g;
    s === void 0 && (s = 1);
    for (var _ = 0; _ < s; ++_)
      for (e += (o - e) * i, f.forEach(function(x) {
        x(e);
      }), u = 0; u < c; ++u)
        g = t[u], g.fx == null ? g.x += g.vx *= l : (g.x = g.fx, g.vx = 0), g.fy == null ? g.y += g.vy *= l : (g.y = g.fy, g.vy = 0);
    return n;
  }
  function y() {
    for (var s = 0, u = t.length, c; s < u; ++s) {
      if (c = t[s], c.index = s, c.fx != null && (c.x = c.fx), c.fy != null && (c.y = c.fy), isNaN(c.x) || isNaN(c.y)) {
        var g = Ut * Math.sqrt(0.5 + s), _ = s * qt;
        c.x = g * Math.cos(_), c.y = g * Math.sin(_);
      }
      (isNaN(c.vx) || isNaN(c.vy)) && (c.vx = c.vy = 0);
    }
  }
  function w(s) {
    return s.initialize && s.initialize(t, v), s;
  }
  return y(), n = {
    tick: p,
    restart: function() {
      return h.restart(d), n;
    },
    stop: function() {
      return h.stop(), n;
    },
    nodes: function(s) {
      return arguments.length ? (t = s, y(), f.forEach(w), n) : t;
    },
    alpha: function(s) {
      return arguments.length ? (e = +s, n) : e;
    },
    alphaMin: function(s) {
      return arguments.length ? (r = +s, n) : r;
    },
    alphaDecay: function(s) {
      return arguments.length ? (i = +s, n) : +i;
    },
    alphaTarget: function(s) {
      return arguments.length ? (o = +s, n) : o;
    },
    velocityDecay: function(s) {
      return arguments.length ? (l = 1 - s, n) : 1 - l;
    },
    randomSource: function(s) {
      return arguments.length ? (v = s, f.forEach(w), n) : v;
    },
    force: function(s, u) {
      return arguments.length > 1 ? (u == null ? f.delete(s) : f.set(s, w(u)), n) : f.get(s);
    },
    find: function(s, u, c) {
      var g = 0, _ = t.length, x, m, b, E, A;
      for (c == null ? c = 1 / 0 : c *= c, g = 0; g < _; ++g)
        E = t[g], x = s - E.x, m = u - E.y, b = x * x + m * m, b < c && (A = E, c = b);
      return A;
    },
    on: function(s, u) {
      return arguments.length > 1 ? (a.on(s, u), n) : a.on(s);
    }
  };
}
function gt() {
  var t, n, e, r, i = N(-30), o, l = 1, f = 1 / 0, h = 0.81;
  function a(y) {
    var w, s = t.length, u = H(t, Gt, Jt).visitAfter(d);
    for (r = y, w = 0; w < s; ++w)
      n = t[w], u.visit(p);
  }
  function v() {
    if (t) {
      var y, w = t.length, s;
      for (o = new Array(w), y = 0; y < w; ++y)
        s = t[y], o[s.index] = +i(s, y, t);
    }
  }
  function d(y) {
    var w = 0, s, u, c = 0, g, _, x;
    if (y.length) {
      for (g = _ = x = 0; x < 4; ++x)
        (s = y[x]) && (u = Math.abs(s.value)) && (w += s.value, c += u, g += u * s.x, _ += u * s.y);
      y.x = g / c, y.y = _ / c;
    } else {
      s = y, s.x = s.data.x, s.y = s.data.y;
      do
        w += o[s.data.index];
      while (s = s.next);
    }
    y.value = w;
  }
  function p(y, w, s, u) {
    if (!y.value)
      return !0;
    var c = y.x - n.x, g = y.y - n.y, _ = u - w, x = c * c + g * g;
    if (_ * _ / h < x)
      return x < f && (c === 0 && (c = k(e), x += c * c), g === 0 && (g = k(e), x += g * g), x < l && (x = Math.sqrt(l * x)), n.vx += c * y.value * r / x, n.vy += g * y.value * r / x), !0;
    if (y.length || x >= f)
      return;
    (y.data !== n || y.next) && (c === 0 && (c = k(e), x += c * c), g === 0 && (g = k(e), x += g * g), x < l && (x = Math.sqrt(l * x)));
    do
      y.data !== n && (_ = o[y.data.index] * r / x, n.vx += c * _, n.vy += g * _);
    while (y = y.next);
  }
  return a.initialize = function(y, w) {
    t = y, e = w, v();
  }, a.strength = function(y) {
    return arguments.length ? (i = typeof y == "function" ? y : N(+y), v(), a) : i;
  }, a.distanceMin = function(y) {
    return arguments.length ? (l = y * y, a) : Math.sqrt(l);
  }, a.distanceMax = function(y) {
    return arguments.length ? (f = y * y, a) : Math.sqrt(f);
  }, a.theta = function(y) {
    return arguments.length ? (h = y * y, a) : Math.sqrt(h);
  }, a;
}
function tn(t, n, e) {
  var r, i = N(0.1), o, l;
  typeof t != "function" && (t = N(+t)), n == null && (n = 0), e == null && (e = 0);
  function f(a) {
    for (var v = 0, d = r.length; v < d; ++v) {
      var p = r[v], y = p.x - n || 1e-6, w = p.y - e || 1e-6, s = Math.sqrt(y * y + w * w), u = (l[v] - s) * o[v] * a / s;
      p.vx += y * u, p.vy += w * u;
    }
  }
  function h() {
    if (r) {
      var a, v = r.length;
      for (o = new Array(v), l = new Array(v), a = 0; a < v; ++a)
        l[a] = +t(r[a], a, r), o[a] = isNaN(l[a]) ? 0 : +i(r[a], a, r);
    }
  }
  return f.initialize = function(a) {
    r = a, h();
  }, f.strength = function(a) {
    return arguments.length ? (i = typeof a == "function" ? a : N(+a), h(), f) : i;
  }, f.radius = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : N(+a), h(), f) : t;
  }, f.x = function(a) {
    return arguments.length ? (n = +a, f) : n;
  }, f.y = function(a) {
    return arguments.length ? (e = +a, f) : e;
  }, f;
}
function nn(t) {
  var n = N(0.1), e, r, i;
  typeof t != "function" && (t = N(t == null ? 0 : +t));
  function o(f) {
    for (var h = 0, a = e.length, v; h < a; ++h)
      v = e[h], v.vx += (i[h] - v.x) * r[h] * f;
  }
  function l() {
    if (e) {
      var f, h = e.length;
      for (r = new Array(h), i = new Array(h), f = 0; f < h; ++f)
        r[f] = isNaN(i[f] = +t(e[f], f, e)) ? 0 : +n(e[f], f, e);
    }
  }
  return o.initialize = function(f) {
    e = f, l();
  }, o.strength = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : N(+f), l(), o) : n;
  }, o.x = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : N(+f), l(), o) : t;
  }, o;
}
function en(t) {
  var n = N(0.1), e, r, i;
  typeof t != "function" && (t = N(t == null ? 0 : +t));
  function o(f) {
    for (var h = 0, a = e.length, v; h < a; ++h)
      v = e[h], v.vy += (i[h] - v.y) * r[h] * f;
  }
  function l() {
    if (e) {
      var f, h = e.length;
      for (r = new Array(h), i = new Array(h), f = 0; f < h; ++f)
        r[f] = isNaN(i[f] = +t(e[f], f, e)) ? 0 : +n(e[f], f, e);
    }
  }
  return o.initialize = function(f) {
    e = f, l();
  }, o.strength = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : N(+f), l(), o) : n;
  }, o.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : N(+f), l(), o) : t;
  }, o;
}
const rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  forceCenter: rt,
  forceCollide: ot,
  forceLink: ft,
  forceManyBody: gt,
  forceRadial: tn,
  forceSimulation: ht,
  forceX: nn,
  forceY: en
}, Symbol.toStringTag, { value: "Module" }));
class an {
  constructor(n = {}) {
    this.options = n;
  }
  activate(n) {
    const { nodePositions: e, nodes: r, edges: i, emitter: o, svgPanZoom: l } = n;
    let { nodeLayouts: f, nodeLayoutMap: h } = this.buildNodeLayouts(r.value, e, {
      x: 0,
      y: 0
    });
    const a = this.createSimulation(
      f,
      this.forceLayoutEdges(i.value, r.value)
    );
    a.on("tick", () => {
      var s, u, c;
      for (const g of f) {
        const _ = (s = e.value) == null ? void 0 : s[g.id];
        _ && (_.x = (u = g.x) != null ? u : 0, _.y = (c = g.y) != null ? c : 0);
      }
    });
    const v = () => {
      a.alpha(0.1).restart();
    }, d = (s) => {
      for (const [u, c] of Object.entries(s)) {
        const g = h[u];
        g.fx = c.x, g.fy = c.y;
      }
      v();
    }, p = (s) => {
      var u;
      for (const [c, g] of Object.entries(s)) {
        const _ = this.getNodeLayout(e, c), x = (u = h == null ? void 0 : h[c]) != null ? u : { x: 0, y: 0 };
        _.value.fixed || this.options.positionFixedByDrag ? (x.fx = g.x, x.fy = g.y, _.value.fixed = !0) : (x.x = g.x, x.y = g.y, delete x.fx, delete x.fy);
      }
      v();
    }, y = ({ node: s, event: u }) => {
      if (this.options.positionFixedByClickWithAltKey && u.altKey) {
        const c = this.getNodeLayout(e, s);
        let g = h == null ? void 0 : h[s];
        g || (g = { id: s, x: 0, y: 0 }, h[s] = g), c.value.fixed ? (delete c.value.fixed, g.x = g.fx || g.x, g.y = g.fy || g.y, delete g.fx, delete g.fy) : (c.value.fixed = !0, g.fx = g.x, g.fy = g.y), v();
      }
    }, w = dt(
      () => [
        Object.keys(r.value),
        // Watch only for changes in links, not all properties of the edge objects.
        Object.values(i.value).map((s) => `${s.source}=${s.target}`)
      ],
      () => {
        const s = l.getViewArea();
        ({ nodeLayouts: f, nodeLayoutMap: h } = this.buildNodeLayouts(
          r.value,
          e,
          s.center
        )), a.nodes(f);
        const u = a.force("edge");
        u && u.links(this.forceLayoutEdges(i.value, r.value)), v();
      }
    );
    o.on("node:dragstart", d), o.on("node:pointermove", d), o.on("node:dragend", p), o.on("node:click", y), this.onDeactivate = () => {
      a.stop(), w(), o.off("node:dragstart", d), o.off("node:pointermove", d), o.off("node:dragend", p), o.off("node:click", y);
    };
  }
  deactivate() {
    this.onDeactivate && this.onDeactivate();
  }
  createSimulation(n, e) {
    if (this.options.createSimulation)
      return this.options.createSimulation(rn, n, e);
    {
      const r = ft(e).id((i) => i.id);
      return ht(n).force("edge", r.distance(100)).force("charge", gt()).force("collide", ot(50).strength(0.2)).force("center", rt().strength(0.05)).alphaMin(1e-3);
    }
  }
  buildNodeLayouts(n, e, r) {
    const i = Object.keys(n).filter((f) => !(f in e.value));
    for (const f of i)
      e.value[f] = C({}, r);
    const o = this.forceNodeLayouts(e.value), l = Object.fromEntries(o.map((f) => [f.id, f]));
    return { nodeLayouts: o, nodeLayoutMap: l };
  }
  forceNodeLayouts(n) {
    return Object.entries(n).map(([e, r]) => r.fixed ? J(C({ id: e }, r), { fx: r.x, fy: r.y }) : C({ id: e }, r));
  }
  forceLayoutEdges(n, e) {
    return Object.values(n).filter((r) => r.source in e && r.target in e).map((r) => ({
      source: r.source,
      target: r.target
    }));
  }
  getNodeLayout(n, e) {
    const r = _t(n.value, e);
    return r.value || (r.value = { x: 0, y: 0 }), r;
  }
}
export {
  an as ForceLayout
};
//# sourceMappingURL=force-layout.mjs.map
